import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";
import Skeletons from "./Skeletons";

const GoLiveHeaderSkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={[
        {
          marginHorizontal: 15,
          flexDirection:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "row" : "column",
        },
      ]}
    >
      {deviceSize === DEVICE_SIZES.XS ||
      deviceSize === DEVICE_SIZES.SM ? null : (
        <View
          style={[
            {
              gap: 10,
              alignSelf: "center",
              marginVertical: 10,
              marginLeft: 35,
              marginRight: 50,
              flexDirection:
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? "row"
                  : "column",
            },
          ]}
        >
          <Skeletons
            height={33}
            width={"120px"}
            style={{
              borderRadius: 10,
              marginLeft: 10,
            }}
          />
        </View>
      )}

      <View
        style={[
          {
            gap: 10,
            flexDirection:
              deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "row" : "column",
            alignSelf: "center",
            marginVertical: 10,
          },
        ]}
      >
        <View style={{ flexDirection: "row", columnGap: 10 }}>
          <View>
            <Skeletons
              height={45}
              width={"165px"}
              style={{
                borderRadius: 10,
                marginLeft: 10,
              }}
            />
          </View>
          <View>
            <Skeletons
              height={45}
              width={"192px"}
              style={{
                borderRadius: 10,
              }}
            />
          </View>
          <View>
            <Skeletons
              height={45}
              width={"202px"}
              style={{
                borderRadius: 10,
              }}
            />
          </View>
        </View>
        <View style={{ flexDirection: "row", columnGap: 10 }}>
          <View>
            <Skeletons
              height={45}
              width={"165px"}
              style={{
                borderRadius: 10,
              }}
            />
          </View>
          <View>
            <Skeletons
              height={45}
              width={"127px"}
              style={{
                borderRadius: 10,
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default GoLiveHeaderSkeleton;
